import { useState, useEffect } from 'react';
import type { Verse } from '../../../shared/types/bible';
import { bibleApi } from '../../../shared/api/bibleApi';

export function useVerseExplanation(verse?: Verse) {
  const [explanation, setExplanation] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!verse?.book || !verse?.chapter || !verse?.verse) return;

    let isMounted = true;
    setIsLoading(true);

    const fetchExplanation = async () => {
      try {
        const verseReference = `${verse.book} ${verse.chapter}:${verse.verse}`;
        const explanation = await bibleApi.getVerseExplanation(verseReference);
        if (isMounted) {
          setExplanation(explanation || 'No explanation available.');
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error in useVerseExplanation:', error);
          setExplanation('Unable to load explanation at this time.');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchExplanation();

    return () => {
      isMounted = false;
    };
  }, [verse?.book, verse?.chapter, verse?.verse]);

  return { explanation, isLoading };
}